import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormsModule, NgForm } from '@angular/forms';
import { GwrFormService } from '../../../gwr-form.service';
import { keysToTranslate } from 'i18n/keys-to-translate';
import { Subscription } from 'rxjs';
import { GwrGemeindeComponent } from '../../../gwr-gemeinde/gwr-gemeinde/gwr-gemeinde.component';
import { SearchStateService } from '../../../../shared/services/search-state.service';
import { AbstractSearchComponent } from '../../../../shared/components/abstract-component/abstract-search.component';
import { SearchMode } from '../../../../shared/enum/searchMode';
import { GwrgebaeudeService, GwrGebaeudeStandardRequestMeta } from '../../../../core/gwr-api';
import { MetaDirective } from '../../../../shared/directives/meta.directive';
import { CapFormRowDirective } from '../../../../shared/form-control/cap-form-row.directive';
import { CapFormControlComponent } from '../../../../shared/form-control/form-control.component';
import { MetaDisablerDirective } from '../../../../shared/directives/meta-disabler.directive';
import { MetaValidatorDirective } from '../../../../shared/directives/meta-validator.directive';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'cap-gwr-gebaeude-suche-standard',
  templateUrl: './gwr-gebaeude-suche-standard.component.html',
  styleUrls: ['./gwr-gebaeude-suche-standard.component.scss'],
  imports: [
    FormsModule,
    MetaDirective,
    CapFormRowDirective,
    CapFormControlComponent,
    GwrGemeindeComponent,
    MetaDisablerDirective,
    MetaValidatorDirective,
    TranslatePipe
  ]
})
export class GwrGebaeudeSucheStandardComponent extends AbstractSearchComponent implements OnInit, OnDestroy {
  @ViewChild('form', { static: false })
  form: NgForm;

  @ViewChild(GwrGemeindeComponent, { static: false })
  private gwrGemeindeComponent: GwrGemeindeComponent;

  standardRequest: GwrGebaeudeStandardRequestMeta;

  searchForEgrid: boolean;

  private subscription: Subscription = new Subscription();

  constructor(
    stateService: SearchStateService,
    private route: ActivatedRoute,
    private router: Router,
    private formService: GwrFormService,
    private gwrgebaeudeService: GwrgebaeudeService
  ) {
    super(stateService);
    keysToTranslate<string>([
      'Baujahr',
      'GemeindeMussVorhandenSein',
      'StrasseOderHausnummer',
      'grundstueckHeading',
      'gebäudeeingangHeading',
      'gwr.EingabeMussGueltigeStrasseSein'
    ]);
  }

  ngOnInit() {
    this.subscription = this.gwrgebaeudeService.searchGebaeudeStandardTemplate().subscribe((template) => {
      this.standardRequest = this.copyLastRequest(template);
      this.searchForEgrid = template.mEgrid.access !== 'DEACTIVATED';
    });
  }

  onSubmit(): void {
    if (this.standardRequest.egrid && this.standardRequest.egrid.value) {
      this.standardRequest.egrid.value = this.standardRequest.egrid.value.replace(/\s/g, '');
    }
    this.stateService.lastRequest = this.standardRequest;
    this.formService.submit(this.form, SearchMode.searchStandard, this.standardRequest, this.router, this.route, true);
  }

  onReset() {
    this.form.reset();
    this.subscription.add(
      this.gwrgebaeudeService.searchGebaeudeStandardTemplate().subscribe((template) => {
        this.standardRequest = template;
        this.stateService.lastRequest = null;
      })
    );
  }

  emptyGemeindeSearch() {
    if (this.stateService.lastRequest) {
      this.stateService.lastRequest.bfsNummer = null;
      this.stateService.lastRequest.gemeindeId = null;
    }
    this.gwrGemeindeComponent.onClear();
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }
}
